import React, { useState } from 'react'
import {
  InputLabel,
  Dialog,
  Grid
} from '@material-ui/core'
import { StyledDialogTitle, StyledButton, StyledMenuItem } from '../../../../../../theme/Global'
import {
  StyledCloseButton,
  StyledDialogContent,
  StyledProductGrid,
  StyledFormControl,
  StyledSelect,
  StyledButtonsGrid,
  StyledExportContainer
} from './styles'

const ExportModal = ({ open, close, exporter }) => {
  const productSelections = Object.freeze({
    all: { id: 'allPaidLeaveTypes', text: 'All Locations with Paid Leave Type' },
    paidSickLeave: { id: 'paidSickLeave', text: 'Paid Sick Leave Locations' },
    paidFamilyMedicalLeave: {
      id: 'paidFamilyMedicalLeave',
      text: 'Paid Family and Medical Leave Locations'
    },
    paidLeave: { id: 'paidLeave', text: 'Paid Leave - Miscellaneous Locations' }
  })

  const [selection, setSelection] = useState(productSelections.all.id)

  const handleChange = (event) => {
    setSelection(event.target.value)
  }

  const handleExport = () => {
    exporter(selection)
    close()
  }

  return (
    <Dialog title="Export locations" open={open} onClose={close} maxWidth="md">
      <StyledDialogTitle>
        Export Locations
        <StyledCloseButton onClick={close} />
      </StyledDialogTitle>
      <StyledDialogContent>
        <StyledProductGrid container spacing={8}>
          <StyledFormControl>
            <InputLabel>Select Product</InputLabel>
            <StyledSelect value={selection} onChange={handleChange}>
              {Object.keys(productSelections).map((key) => (
                <StyledMenuItem value={productSelections[key].id}>
                  {productSelections[key].text}
                </StyledMenuItem>
              ))}
            </StyledSelect>
          </StyledFormControl>
        </StyledProductGrid>
        <StyledButtonsGrid container spacing={24}>
          <StyledExportContainer item>
            <StyledButton
              color="secondary"
              variant="contained"
              onClick={() => handleExport()}
            >
              Export
            </StyledButton>
          </StyledExportContainer>
          <Grid item>
            <StyledButton
              color="secondary"
              variant="contained"
              onClick={() => close()}
            >
              Cancel
            </StyledButton>
          </Grid>
        </StyledButtonsGrid>
      </StyledDialogContent>
    </Dialog>
  )
}

export default ExportModal
